(() => {
  const replacements = [
    [/FREE GIFTS with your order/gi, 'CADEAUX OFFERTS avec votre commande'],
    [/Free Express Shipping/gi, 'Livraison express gratuite'],
    [/50 pc inside!/gi, '50 pièces incluses !'],
    [/7 magic markers/gi, '7 feutres magiques'],
    [/EARLY BLACK FRIDAY/gi, 'BLACK FRIDAY EN AVANCE'],
    [/BUY ONE GET ONE FREE/gi, 'UN ACHETÉ, UN OFFERT'],
    [/Buy one, get one FREE/gi, 'Un acheté, un offert'],
    [/Two for /g, 'Deux pour '],
    [/Free shipping/gi, 'Livraison gratuite'],
    [/2 INCLUDED - worth /g, '2 INCLUS – valeur de '],
    [/Both are already included in the offer\./g, 'Les deux articles sont déjà inclus dans l’offre.'],
    [/^\s*FREE\s*$/i, 'OFFERT']
  ];
  const attached = new WeakSet();
  function translate(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.parentElement && !node.parentElement.closest('script,style,textarea,input,select')) nodes.push(node);
    }
    for (const node of nodes) {
      let value = node.nodeValue;
      for (const [pattern, replacement] of replacements) value = value.replace(pattern, replacement);
      if (value !== node.nodeValue) node.nodeValue = value;
    }
  }
  function attach() {
    document.querySelectorAll('moonbundle-component').forEach(root => {
      if (attached.has(root)) return;
      attached.add(root);
      translate(root);
      const observer = new MutationObserver(() => {
        observer.disconnect();
        translate(root);
        observer.observe(root, {childList: true, subtree: true, characterData: true});
      });
      observer.observe(root, {childList: true, subtree: true, characterData: true});
    });
  }
  attach();
  new MutationObserver(attach).observe(document.documentElement, {childList: true, subtree: true});
})();